import { movieData } from "../db/movieData" 
import { MovieCard } from "./MovieCard"
import '../styles/movieCard.css'
import { useEffect } from "react";
import { useState } from "react";
import { MovieModal } from "./MovieModal";
import { FilterBar } from './FilterBar';


const sortByPrice = (movieA, movieB) =>
{
    return movieA.price - movieB.price;
}

const sortByRelease = (movieA, movieB) =>
{
    return new Date(movieA.released) - new Date(movieB.released);
}

const sortByRating = (movieA, movieB) =>
{
    return parseInt(movieA.metascore) - parseInt(movieB.metascore);
}

const sortByTitle = (movieA, movieB) =>
{
    if (movieA.title < movieB.title) return -1;
    if (movieA.title > movieB.title) return 1;
    return 0;
}

const sortParams = {
    Price: sortByPrice,
    Release: sortByRelease,
    Rating: sortByRating,
    Title: sortByTitle
}

export const MovieGrid = ({searchParams, setSearchParams}) =>
{
    const [movies, setMovies] = useState(movieData);
    const [isLoading, setLoading] = useState(true);
    
    const [movieModal, setMovieModal] = useState({});


    useEffect(() =>
    {
        const genre = searchParams.get('genre');
        const search = searchParams.get('search');
        const sort = searchParams.get('sort_by');
        
        let data = [...movieData];

        if (genre) data = data.filter((movie) =>
        {
            return movie.genre.toLowerCase().includes(genre.toLowerCase())
        })
        if (search) data = data.filter((movie) =>
        {
            return movie.title.toLowerCase().includes(search.toLowerCase())
        })
        if (sort)
        {
            data.sort(sortParams[sort]);
        }

        setMovies(data);
        setLoading(false);
    }, [isLoading, searchParams])

    const onExpand = (movie) =>
    {
        setMovieModal(movie);
        window.$('#movieModal').modal('show');
    }

    const [pageNumber, setPageNumber] = useState(0);

    const perPage = 20;
    const visited = pageNumber * perPage;

    const pages = movies.slice(visited, visited+perPage);

    const pageCount = Math.ceil(movies.length/perPage);

    const changePage = ({selected}) =>
    {
        setPageNumber(selected);
    }

    return <div>
        <FilterBar setSearchParams={setSearchParams} pageCount={pageCount} changePage={changePage} id={"upper"}/>
        <div className="movie-grid">
            {pages.map((movie, index) => {
                return <MovieCard movie={movie} key={index} onExpand={() => onExpand(movie)}/>
            })}
            <MovieModal movie={movieModal}/>
        </div>
        <FilterBar setSearchParams={setSearchParams} pageCount={pageCount} changePage={changePage} id={"lower"}/>
    </div>
}
